import TableTorch from "modules/5_view_helpers/web/TableTorch";
import React, { Fragment } from "react";
import columns from "../columns";
import { Field, Form } from "react-final-form";
import { ToggleField } from "modules/4_final_form/web";
import { Button, ButtonGroup, Col, FormGroup, Label, Modal, ModalBody, ModalHeader, Row } from "reactstrap";
import qs from "query-string";
import { openAuthenticatedPdf } from "modules/5_view_helpers/openPdf";

const BoltedConnectionsTable = (props) => {
  const [selectedIDS, setSelectedIDS] = React.useState([]);
  const { project_qa_bolted_connections, project_id, showEdit, updateRole } = props;
  const ordered = _.orderBy(project_qa_bolted_connections, ["main_assembly"]);

  const [reportModal, setReportModal] = React.useState(false);
  const toggleReportModal = () => setReportModal(!reportModal);

  return (
    <Fragment>
      <Modal size="lg" isOpen={reportModal} toggle={toggleReportModal}>
        <ModalHeader>Bolted Connections Report Options</ModalHeader>
        <ModalBody>
          <Form
            onSubmit={(options) => {
              const newOptions = { ...options, id: selectedIDS };
              const query = qs.stringify(newOptions, { arrayFormat: 'comma' });
              openAuthenticatedPdf(`/project/${project_id}/qa/bolted_connections.pdf?${query}`);
            }}
            render={({ handleSubmit }) => (
              <form onSubmit={handleSubmit}>
                <FormGroup row>
                  <Label md={3}>Main Assembly</Label>
                  <Col md={3}>
                    <Field name="show_main_assembly" title="Main Assembly" defaultValue={true} component={ToggleField} />
                  </Col>
                  <Label md={3}>Connected Assemblies</Label>
                  <Col md={3}>
                    <Field name="show_connected_assemblies" title="Connected Assemblies" defaultValue={true} component={ToggleField} />
                  </Col>
                </FormGroup>
                <FormGroup row>
                  <Label md={3}>Phase</Label>
                  <Col md={3}>
                    <Field name="show_phase" title="Phase" defaultValue={true} component={ToggleField} />
                  </Col>
                  <Label md={3}>Lot</Label>
                  <Col md={3}>
                    <Field name="show_lot" title="Lot" defaultValue={true} component={ToggleField} />
                  </Col>
                </FormGroup>
                <FormGroup row>
                  <Label md={3}>QTY</Label>
                  <Col md={3}>
                    <Field name="show_qty" title="QTY" defaultValue={true} component={ToggleField} />
                  </Col>
                  <Label md={3}>Size</Label>
                  <Col md={3}>
                    <Field name="show_size" title="Size" defaultValue={true} component={ToggleField} />
                  </Col>
                </FormGroup>
                <FormGroup row>
                  <Label md={3}>Grade</Label>
                  <Col md={3}>
                    <Field name="show_grade" title="Grade" defaultValue={true} component={ToggleField} />
                  </Col>
                  <Label md={3}>Joint Type</Label>
                  <Col md={3}>
                    <Field name="show_joint_type" title="Joint Type" defaultValue={true} component={ToggleField} />
                  </Col>
                </FormGroup>
                <FormGroup row>
                  <Label md={3}>Batch Number</Label>
                  <Col md={3}>
                    <Field name="show_batch_number" title="Batch Number" defaultValue={true} component={ToggleField} />
                  </Col>

                  <Label md={3}>Tensioned By</Label>
                  <Col md={3}>
                    <Field name="show_tensioned_by" title="Tensioned By" defaultValue={true} component={ToggleField} />
                  </Col>
                </FormGroup>
                <FormGroup row>
                  <Label md={3}>Inspected By</Label>
                  <Col md={3}>
                    <Field name="show_inspected_by" title="Inspected By" defaultValue={true} component={ToggleField} />
                  </Col>

                  <Label md={3}>Inspected Date</Label>
                  <Col md={3}>
                    <Field name="show_inspected_date" title="Inspected Date" defaultValue={true} component={ToggleField} />
                  </Col>
                </FormGroup>
                <hr />
                <ButtonGroup row>
                  <Button onClick={handleSubmit} color="success">
                    Get Report
                  </Button>
                </ButtonGroup>
              </form>
            )}
          />
        </ModalBody>
      </Modal>

      <Row>
        <Col className="text-right">
          <Button onClick={toggleReportModal}> Get Report</Button>
        </Col>
      </Row>
      <TableTorch
        columns={columns(updateRole, project_id, showEdit)}
        data={ordered}
        selectable
        onSelect={(rows) => {
          setSelectedIDS(rows.map((row) => row.id));
        }}
      />
    </Fragment>
  );
};

BoltedConnectionsTable.defaultProps = {
  showEdit: true,
};

export default BoltedConnectionsTable;
